"use client";
import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "@/redux/hook";
import { addProductRecentView } from "@/redux/features/ShopSlice";
import { addProductRecentViewToLocal } from "@/lib/api/shop/products";
import {
	ProductJson,
	ProductDescriptionSetting,
	Images,
} from "@/types/Product.type";

import CardSkeleton from "~components/card/children/CardSkeleton";
import ProductTester from "./_components/productTester/ProductTester";
import ProductPolicy from "./_components/productPolicy/ProductPolicy";
import { VariantsFromTags } from "@/lib/hooks/useVariants";
import ProductVariantGroup from "~components/product/ProductVariantGroup";
import ProductInfoMobile from "./_components/productInfo/ProductInfoMobile";
import ProductImagesMobile from "./_components/productImages/ProductImagesMobile";
import ProductActionsMobile from "./_components/productActions/ProductActionsMobile";
import useVariantsV2 from "@/lib/hooks/useVariantsV2";
import ProductDescriptionsMobile from "../productDescriptions/ProductDescriptionsMobile";
import ProductErrorQuantity from "~components/product/ProductErrorQuantity";
import ProductMyPromotions from "./_components/productMyPromotions/ProductMyPromotions";

interface ProductDetailProps {
	product: ProductJson;
	store_id: number;
	descriptions: ProductDescriptionSetting[];
	variants?: ProductJson[];
	variantFromTags?: VariantsFromTags[];
	className?: string;
}
function ProductDetailMobile({
	product,
	store_id,
	descriptions,
	variantFromTags: variantStructSize,
	variants: variantlist,
	className,
}: ProductDetailProps) {
	const dispatch = useAppDispatch();

	const productRecentViewList = useAppSelector(
		(state) => state.ShopReducer.listProductRecentView
	);

	const {
		handleActiveVariant,
		variantActive,
		variantFromTags,
		isLoading,
		refetch,
		variants,
		error,
	} = useVariantsV2({
		product: product,
		variantFromTagsDefauilt: variantStructSize,
		variantsDefauilt: variantlist,
	});

	const [imageActive, setImageActive] = useState<number>(0);
	const [listImageActive, setListImageActive] = useState<Images[]>(
		product.images
	);

	// init
	useEffect(() => {
		if (productRecentViewList.length) {
			dispatch(addProductRecentView(product));
		} else {
			addProductRecentViewToLocal(product.id);
		}
	}, [product.id]);

	useEffect(() => {
		if (variantActive.images.length) {
			setListImageActive(variantActive.images);
		} else {
			setListImageActive([{ url: "" }]);
		}
	}, [variantActive, isLoading]);

	return (
		<div className={className}>
			<div className="min-h-[400px]">
				<ProductInfoMobile data={product} className="mt-2" />
				<div className="relative">
					{isLoading ? (
						<div className="min-h-[50vh] flex items-center justify-center">
							<CardSkeleton />
						</div>
					) : (
						<ProductImagesMobile
							images={listImageActive}
							indexActive={imageActive}
							onChangeImage={(value) => {
								setImageActive(value);
							}}
						/>
					)}

					{variantActive.tags.some(
						(item) => item.type === "PRODUCT TESTER"
					) && (
						<div className="absolute top-2 left-2 z-10">
							<ProductTester tags={variantActive.tags} />
						</div>
					)}
				</div>
				<div className="mt-3">
					{!error ? (
						<ProductActionsMobile
							store_id={store_id}
							productVariant={variantActive}
							product={product}
						/>
					) : (
						<ProductErrorQuantity onClick={refetch} />
					)}
				</div>
				<ProductPolicy className="md:pt-4" />
				<ProductVariantGroup
					loading={isLoading}
					variantActive={variantActive}
					variantFromTags={variantFromTags}
					handleActiveVariant={handleActiveVariant}
					className="px-4 py-3"
					classNameGroup=" gap-4"
					classNameItem=" py-[5px] px-2"
				/>
				<div className=" px-2">
					<ProductMyPromotions />
				</div>
				<ProductDescriptionsMobile
					sku={variantActive.sku}
					product={product}
					descriptions={descriptions}
					className="w-full mb-3 lg:mt-20"
				/>
			</div>
		</div>
	);
}

export default ProductDetailMobile;
